import { Pagination, PaginationItem } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { DataGrid, GridRowId, GridSortDirection, gridPageCountSelector, gridPageSelector, gridPaginationSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { useEffect, useState } from 'react';
import { AddEquipmentButton, LongBlueButton, RecordTableContainer, RedButton, WhiteContainer } from '../assets/style';
import { useTranslation } from "react-i18next";
export interface RecordTableProps {
    getRowId?: (x: any) => any
    columns: TableHeader[];
    rows?: TableRow[];
    checkbox?: boolean;
    color?: string;
    deleteButton?: boolean;
    onClick?: (row: TableRow, field?: string) => void; // Add the onClick prop
    onSelectRows?: (selectedRows: any[]) => void;
    selectedRows?: TableRow[];
    pages?: number
}

export interface TableRow {
    id: any;
    data?: Array<React.ReactNode>;
    checked?: boolean;
}

export interface TableHeader {
    field: string;
    headerName: string;
    isSortable?: boolean;
    width: number;
    renderCell?: any;
}

const RecordTable: React.FC<RecordTableProps> = ({ getRowId, columns, rows, checkbox, color, deleteButton, onClick, onSelectRows, selectedRows, pages }) => {
    const [sortBy, setSortBy] = useState('');
    const [direction, setDirection] = useState('');
    const [deletedRows, setDeletedRows] = useState<TableRow[]>([]);
    var selectedRowData;
    const [selectionModel, setSelectionModel] = useState<any>();
    const { t, i18n } = useTranslation();
    // console.log("page ", pages)
    useEffect(() => {
        setSelectionModel(() =>
            rows
                ?.filter((r) => selectedRows?.some((row) => row.id === r.id))
                .map((r) => r.id))
    }, [rows, selectedRows, onSelectRows]);

    const handleDeleteRows: React.MouseEventHandler<HTMLButtonElement> = () => {
        console.log("Deleted rows: ", deletedRows);
    };

    // const handleDeleteRows: React.MouseEventHandler<HTMLButtonElement> = () => {
    //     const remainingRows = rows.filter((row) => !checkedRows[row.id]);
    //     setDeletedRows(checkedRows);
    //     onDeleteRows && onDeleteRows(checkedRows);
    //     setEquipmentRows(remainingRows);
    //     setSelectedRows([]);
    // };

    if (!rows || rows.length === 0) {
        return (
            <WhiteContainer sx={{ margin: "28px", height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {t("No data available")}
            </WhiteContainer>
        );
    }
    const handleRowClick = (params: any) => {
        onClick && onClick(params.row, params?.field);
    };

    var rowCount = rows.length;
    const sortModel = sortBy && direction ? [{ field: sortBy, sort: direction as GridSortDirection }] : [];
    const CustomPagination = () => {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        const paginationState = useGridSelector(apiRef, gridPaginationSelector);

        return (
            <>
                {/* {deleteButton && <RedButton >Delete</RedButton>} */}
                {deleteButton && (
                    <RedButton onClick={handleDeleteRows}>{t("Delete")}</RedButton>
                )}
                <Stack direction="row" spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {paginationState.paginationModel.pageSize * page + 1} - {" "}
                        {(paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize) > rowCount ?
                            (rowCount + " of ")
                            : (paginationState.paginationModel.pageSize * page + paginationState.paginationModel.pageSize + " of ")}{rowCount}
                    </Box>
                    <Pagination
                        color="primary"
                        count={pageCount}
                        page={page + 1}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                        variant="outlined"
                        shape="rounded"
                        sx={{
                            button: { borderColor: "#70BFEC" },
                        }}
                        renderItem={(item) => (
                            <PaginationItem
                                // components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                                sx={{
                                    "&.Mui-selected": {
                                        backgroundColor: "#B6E2FB",
                                        color: "#0D6EFD",
                                        borderColor: "transparent",
                                        fontSize: 16,
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "8px"
                                    }
                                }}
                            />
                        )}
                    />
                </Stack>
            </>
        );
    }

    return (
        <RecordTableContainer>
            <DataGrid
                keepNonExistentRowsSelected
                getRowId={getRowId}
                // columns={columns}
                columns={columns.map((column) => ({
                    ...column,
                    // headerClassName: "custom-header",
                    width: column.width, // Set the column width individually
                    sortable: column.isSortable,
                }))}
                rows={rows}
                // rowSelectionModel={selectedRows?.map(x => x.id)}
                // rowSelectionModel={selectedRows?.map(x => x.id) as GridRowId[]}

                onCellClick={handleRowClick}
                // onRowClick={handleRowClick}
                sx={{
                    '&>.MuiDataGrid-main': {
                        '&>.MuiDataGrid-columnHeaders': {
                            borderBottomColor: '#2C93CD',
                            borderBottomWidth: "3px",
                            background: 'linear-gradient(180deg, #B6E2FB, #70BFEC)', //, #1A89C8

                        },
                    },
                    '& .MuiDataGrid-columnHeaders': { color: '#0D6EFD' },
                    borderColor: 'none',
                    backgroundColor: color ?? color

                }}

                rowSelectionModel={selectionModel}
                onRowSelectionModelChange={(e) => {
                    const selectedIDs = new Set(e);
                    selectedRowData = rows
                        .filter((row) => selectedIDs.has(row.id!))
                        .map((row) => ({
                            ...row,
                            checked: true, // Set the checked property to true for the selected rows
                        }));

                    setDeletedRows(selectedRowData)
                    onSelectRows && onSelectRows(selectedRowData);
                    setSelectionModel(e);
                }}
                checkboxSelection={checkbox}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 20 },
                    },
                }}
                slots={{
                    pagination: CustomPagination,
                }}
                // autoHeight={true}
                sortModel={sortModel}
                disableColumnMenu
                onSortModelChange={(model) => {
                    if (model.length > 0) {
                        const { field, sort } = model[0];
                        setSortBy(field);
                        setDirection(sort as string);
                    } else {
                        setSortBy('');
                        setDirection('');
                    }
                }}
            />
        </RecordTableContainer>
    );
};
export default RecordTable;
